export const FLOATING_BUTTON_COLOR = '#161f80';
